<template>
    <div>
        <div class="tip" v-if="showTip" @click="showTip = false">
            <img   src="@/assets/image/share_tip.png" alt="">
        </div>
        
    </div>
</template>

<script>

import api from '@/assets/js/api'
import native from '@/assets/js/native'
import native_zh from '@/assets/js/native_zh'

// console.log(native)
import { cookie } from '@/assets/js/utils'
import appENV from '@/assets/js/env';

export default {
    props: {
        
    },
    data(){
        return {
            actId: 1,
            showTip: false,
           shareData: {}
        }
    },
    mounted() {
        let self =this;
            self.actId = self.query && self.query.__sa || 1;
    },
    methods: {
        //// 1=微信 2=中行APP 3=中银APP
        async init(params = {}){            
            let self = this;
            let opt = Object.assign({}, {
                url: self.getShareUrl(), // 分享地址
                title:'中银基金达人挑战赛，赢airpods，瓜分万元话费好礼', // 分享标题
                content:'快来赢取大奖吧', // 分享描述
                success: function() {
                    self.shareSubApi();
                },
                imgUrl: 'https://weixin.bocim.com/act11pics/share.png' // 分享icon (选填 其他必填)
            },params)

            let fromPlat = await appENV.catch(err => {
                // console.log(err)
            })
            if(fromPlat == 2){//中行APP
                document.title = '中银基金达人挑战赛，赢airpods，瓜分万元话费好礼'
            }
            let shareKey = cookie.get('shareKey'+self.actId);
            // console.log("init",fromPlat)
            if(fromPlat == 1){// 微信
                let params = {
                    title: opt.title,
                    timeline: opt.content,
                    desc: opt.content,
                    link: opt.url,
                    imgUrl: opt.imgUrl,
                    // success: opt.success
                    success: function(){}
                }
                // console.log('微信分享')
                self.$wechat.share(params);                
            }
            // 中行初始化
            let t = setTimeout(()=>{
                clearTimeout(t);
                if(fromPlat == 2){
                    native_zh && native_zh.emit('weixinShare','Y')
                }
            }, 500)
            
        },
        async share(params = {}){
            let self = this;
            let opt = Object.assign({}, {
                url: self.getShareUrl(), // 分享地址
                title:'中银基金达人挑战赛，赢airpods，瓜分万元话费好礼', // 分享标题
                content:'快来赢取大奖吧', // 分享描述
                imgUrl: 'https://weixin.bocim.com/act11pics/share.png' // 分享icon (选填 其他必填)
            },params)

            let fromPlat = await appENV.catch(err => {
                // console.log(err)
            })
            // alert(fromPlat)
            let shareKey = cookie.get('shareKey'+self.actId);
            // 中银
            if(fromPlat == 3){

                // console.log('中银分享')
                native && native.emit('toShare', opt)
                self.showTip = false;
                self.shareSubApi();
            }else{
                self.showTip = true;
            }

            if(fromPlat == 2){
                self.shareSubApi();
            }
        },
        async shareSubApi(){
            let shareRes = await api({
                method: 'share'

            }).catch(err => {
                // console.log(err)
            })
            let {data, code ,msg} = shareRes && shareRes.data;
            
            // hasReward
            if(code ==200){
                // console.log(data, code ,msg)
            }
        },
        getShareUrl(){
            let self = this;
            let shareKey = cookie.get('shareKey'+self.actId);
            //console.log(location.href.substr(0,location.href.indexOf('#'))+'#/' + ((shareKey&&shareKey.length)?shareKey:'') )
            // return location.href.substr(0,location.href.indexOf('#'))+'#/' + ((shareKey&&shareKey.length)?shareKey:'') ;
            // 由于第一个生产地址被微信封禁，所有分享链接重新设置为新的活动地址
            return 'https://weixin.bocim.com/activity/actnew11/#/' + ((shareKey&&shareKey.length)?shareKey:'') ;
        }
    },
}
</script>

<style lang="less">
@import '../assets/css/base.less';
.tip {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.4);
    img {
        width: 100%;
    }
}
</style>